
import Vue from 'vue'
import deepExtend from 'deep-extend'

import store from '@store'
import Model from './Model'

/////////////////////////////////////////////////
// $store2
/////////////////////////////////////////////////

class $store2 extends Model {
  constructor() {
    super()

    // this.$vuex = store

    // {value} is always read-only
    // this.value = {}

    // {model} will bind to a vue-model
    // this.model = {}

    // {call} will reference a function on the model
    // this.call = {}

    // this.map = this.map.bind(this)
    // this.watch = this.watch.bind(this)

    // Aliases
    // window.$sw = this.watch.bind(this)
    // window.$sv = this.value
    // window.$sm = this.model
    // window.$sc = this.call

    // window.addEventListener('load', () => {})
    // this.loadVuexStore(this.$data.models)
  }

  //////////////////////////////////
  // Core
  //////////////////////////////////
  // get $vuex() {
  //   return window.$store
  // }

  // get value() {
  //   return store.getters['store2/models']
  // }

  ffs() {
    window.open('http://www.menet.umn.edu/~dockt036/snake.html', '_blank')
  }

  $log(e) {
    console.warn('$store2', e)
  }

  $error(e) {
    console.error('$store2', e)
  }

  // Load model schemas into store
  // loadVuexStore(models) {
  //   Object.keys(models).forEach((model_name) => {
  //     store.dispatch('store2/setModel', {
  //       model: model_name,
  //       value: deepExtend(this.models[model_name], {})
  //     })
  //   })
  // }

  //////////////////////////////////
  // Methods
  //////////////////////////////////

  mapModels(map) {
    const computed = {}
    Object.entries(map).forEach((e) => {
      const computed_name = e[0], model_path = e[1]
      computed[computed_name] = {
        get() {
          return store.getters['store2/models'][model_path]
        },
        // set(value) {
        //   return this.$vuex.dispatch('store2/setModel', { model, value })
        // }
      }
    })
    return computed
  }

  // watch() { }

  // value() {}

  // model() {}

  // call() {}
}

// Create Global $store2
const store2 = new $store2()

// Call $store2 globally from anywhere
window.$store2 = store2

// Call this.$store2 in Vue components if you prefer...
Vue.prototype.$store2 = store2

// export default { store2 }
